module.exports = __webpack_public_path__ + "static/media/3_of_spades.87a788cb.png";